if (!window.GemmyBrand) {
  window.GemmyBrand = true;

  class GemmySearchPopover extends HTMLElement {
    connectedCallback() {
      this.toggleButton = this.querySelector('[data-gemmy-search-toggle]');
      this.panel = this.querySelector('[data-gemmy-search-panel]');
      this.input = this.querySelector('input[type="search"]');
      if (!this.toggleButton || !this.panel) return;

      this.onToggle = () => this.open ? this.close(true) : this.show();
      this.onDocumentPointerDown = (event) => {
        if (this.open && !this.contains(event.target)) this.close(false);
      };
      this.onKeyDown = (event) => {
        if (event.key === 'Escape' && this.open) this.close(true);
      };
      this.onScroll = () => this.open && this.close(false);

      this.toggleButton.addEventListener('click', this.onToggle);
      document.addEventListener('pointerdown', this.onDocumentPointerDown);
      document.addEventListener('keydown', this.onKeyDown);
      window.addEventListener('scroll', this.onScroll, { passive: true });
    }

    disconnectedCallback() {
      this.toggleButton?.removeEventListener('click', this.onToggle);
      document.removeEventListener('pointerdown', this.onDocumentPointerDown);
      document.removeEventListener('keydown', this.onKeyDown);
      window.removeEventListener('scroll', this.onScroll);
    }

    get open() {
      return this.classList.contains('is-open');
    }

    show() {
      document.querySelectorAll('gemmy-search-popover.is-open').forEach((popover) => {
        if (popover !== this) popover.close(false);
      });
      this.classList.add('is-open');
      this.toggleButton.setAttribute('aria-expanded', 'true');
      this.toggleButton.setAttribute('aria-label', 'Close search');
      this.panel.setAttribute('aria-hidden', 'false');
      window.setTimeout(() => this.input?.focus({ preventScroll: true }), 120);
    }

    close(returnFocus = false) {
      this.classList.remove('is-open');
      this.toggleButton.setAttribute('aria-expanded', 'false');
      this.toggleButton.setAttribute('aria-label', 'Search');
      this.panel.setAttribute('aria-hidden', 'true');
      if (returnFocus) this.toggleButton.focus({ preventScroll: true });
    }
  }

  if (!customElements.get('gemmy-search-popover')) {
    customElements.define('gemmy-search-popover', GemmySearchPopover);
  }

  const reveal = () => {
    const elements = document.querySelectorAll('[data-gemmy-reveal]:not(.is-visible)');
    if (!elements.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      elements.forEach((element) => element.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    elements.forEach((element) => observer.observe(element));
  };

  document.addEventListener('DOMContentLoaded', reveal);
  document.addEventListener('shopify:section:load', reveal);
}
